<template>
  <section class="section-speakers" :style="{ '--speakers-nameColor':template.nameColor,'--speakers-nameSize':template.nameSize,'--speakers-textColor':template.textColor,'--speakers-textSize':template.textSize, '--speakers-titleColor':template.titleColor,'--speakers-titleSize':template.titleSize, '--speakers-subColor':template.subColor,'--speakers-subSize':template.subSize,'--speakers-bgColor': template.backgroundColor, '--title-align': template.titleAlign }">
    <h5>{{ template.title }}</h5>
    <div class="grid-container">
      <div class="speaker-container" v-for="(speaker, i) in speakers" :key="i">
        <div class="speaker-img-container">
          <img :src="speaker.picture" />
        </div>
        <div class="speaker-texts-container">
          <h4 class="speaker-name">{{ speaker.speaker }}</h4>
          <h3>{{ speaker.role }}</h3>
          <div class="speaker-description" v-html="speaker.description"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'Speakers',

  props: {
    eventId: String,
  },

  data() {
    return {
      template: null,
      speakers: [],
    };
  },

  mounted() {
    api
      .get(`event/${this.eventId}/speakers`)
      .then((response) => {
        this.speakers = response.data;
      })
      .catch((err) => {
        console.error(err);
      });
  },

  beforeMount() {
    this.template = this.$store.state.template.home.speakers;
  },
};
</script>

<style lang="scss">
/*TOC
    1.POSITION_AND_SIZE
    2.COLORS+TRANSITIONS
    3.TYPOGRAPHY
    --BREAKPOINT--
*/

/*1.POSITION_AND_SIZE -----------------------------*/
.section-speakers {
  padding-top: 2%;
  padding-bottom: 5%;
  padding-left: 1%;
  padding-right: 1%;

  // Section title
  h5 {
    text-align: var(--title-align);
    padding-left: 7.5%;
    padding-right: 7.5%;
  }

  .grid-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: center;
    padding: 0 40px;
    // Card of speaker: v-for(speaker in speakers)
    .speaker-container {
      max-width: 780px;
      height: auto;
      flex-grow: 1;
      display: flex;
      flex-direction: row;
      align-content: flex-start;
      align-items: flex-start;
      // padding-top: 3%;
      // padding-bottom: 3%;
      // padding-left: 3%;
      // padding-right: 3%;
      margin: 12px;
      padding: 0 0px 10px;
      border-bottom: 1px solid var(--speakers-nameColor);
      @include media('<=phone-plus') {
        flex-direction: column;
      }
      .speaker-img-container {
        width: 35%;
        height: 100%;
        img {
          width: 100%;
          height: auto;
          object-fit: cover;
        }
      }
      .speaker-texts-container {
        display: flex;
        flex-direction: column;
        width: 65%;
        padding-top: 1rem;
        padding-bottom: 1rem;
        padding-left: 2rem;
        padding-right: 1rem;

        @include media('<=phone-plus') {
          padding-left: 0;
          width: 100%;
        }
        // Name of speaker
        .speaker-texts-container h4 {
          padding-bottom: 0.5rem;
        }
        // Speaker role h3
        h3 {
          padding-top: 0.5rem;
          padding-bottom: 1rem;
        }
      }
    }
  }
}

/*2.COLORS+TRANSITIONS ---------------------------*/
.section-speakers {
  background-color: var(--speakers-bgColor);
}
// Section title
.section-speakers h5 {
  color: var(--speakers-titleColor);
  // font-weight: bold;
}
// Border underline of Section title
.section-speakers h5::after {
  border-bottom: 1px solid var(--speakers-titleColor);
}
// Card of speaker: v-for(speaker in speakers)
.speaker-container {
  // background-color: var(--main-color);
  // background-color: whitesmoke;
  width: 100%;
}
// Name of speaker
.speaker-texts-container h4 {
  color: var(--speakers-nameColor);
}
// Speaker role h3
.section-speakers h3 {
  color: var(--speakers-subColor);
}
.speaker-description {
  color: var(--speakers-textColor);
}

/*3.TYPOGRAPHY ------------------------------------*/
// Section title
.section-speakers h5 {
  text-transform: uppercase;
  // font-weight: bold;
  font-size: var(--speakers-titleSize);
  margin-bottom: 5%;
  margin-left: 2px;
  margin-right: 2px;
  word-break: break-word;
  @include media('<=phone-plus') {
    font-size: 2rem;
  }
}
// Name of speaker
.speaker-texts-container h4 {
  margin-top: -9px;
  margin-left: -2px;
  font-weight: normal;
  font-size: var(--speakers-nameSize);
  word-break: break-word;
}
// Speaker role p
.section-speakers h3 {
  margin-top: -5px;
  font-weight: bold;
  font-size: var(--speakers-subSize);
}
// v-html
.speaker-description {
  line-height: 1.2;
  font-size: var(--speakers-textSize);
}

/*X BREAKPOINT XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX*/
// @include media('<=phone-plus') {
//   /*BP-SIZE AND POS (less padding cause screen small) --*/
//   .section-speakers {
//     padding-top: 5%;
//     padding-bottom: 10%;
//     padding-left: 3.5%;
//     padding-right: 3.5%;

//     .grid-container {
//       display: flex;
//       justify-content: center;
//       padding: 0;

//       // Card of speaker: v-for(speaker in speakers)
//       .speaker-container {
//         padding-top: 6%;
//         padding-bottom: 10%;
//         padding-left: 1%;
//         padding-right: 1%;
//         flex-direction: column;
//         align-content: center;
//         align-items: center;
//         width: 100%;

//         .speaker-img-container {
//           align-items: flex-start;
//           width: 86%;

//           .speaker-img-full {
//             width: 100%;
//             max-width: 100%;
//           }
//         }
//         .speaker-texts-container {
//           text-align: left;
//           padding-left: 7%;
//           padding-right: 0%;
//           padding-top: 6%;
//           padding-bottom: 6%;
//           width: 100%;
//         }
//         .speaker-logo {
//           width: 40%;
//         }
//       }
//     }
//   }

//   /*BP-TYPOGRAPHY (bigger fonts in rem) ----------------*/
//   .section-speakers h5 {
//     text-transform: uppercase;
//     // font-weight: bold;
//     font-size: 2rem;
//     @include media('<=phone') {
//       font-size: 9vw;
//     }
//   }
//   // Name of speaker
//   .speaker-texts-container h4 {
//     font-size: 2.4rem;
//   }
//   // Speaker role h3
//   .section-speakers h3 {
//     font-size: 1.3rem;
//   }
//   // v-html
//   .speaker-description {
//     padding-top: 1rem;
//     padding-bottom: 1rem;
//     font-size: 1.3rem;
//     // text-align: justify;
//   }
// }
</style>